import { useCallback, useEffect, useState } from "react";
import {
  logout as authLogout,
  isAuthenticated,
  refreshTokens,
  startLogin,
} from "../lib/auth";

/** 認証状態を管理するカスタムフック（トークンリフレッシュ・ログイン・ログアウト） */
export const useAuth = () => {
  const [authenticated, setAuthenticated] = useState(isAuthenticated());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tryRestore = async () => {
      if (!isAuthenticated()) {
        const restored = await refreshTokens();
        setAuthenticated(restored);
      } else {
        setAuthenticated(true);
      }
      setLoading(false);
    };
    tryRestore();
  }, []);

  const login = useCallback(async () => {
    await startLogin();
  }, []);

  const logout = useCallback(() => {
    authLogout();
    setAuthenticated(false);
  }, []);

  return { authenticated, loading, login, logout };
};
